/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
    PageableToJSONTyped,
} from './Pageable';
import type { TimeslotResponse } from './TimeslotResponse';
import {
    TimeslotResponseFromJSON,
    TimeslotResponseFromJSONTyped,
    TimeslotResponseToJSON,
    TimeslotResponseToJSONTyped,
} from './TimeslotResponse';

/**
 * Response paginated for timeslots
 * @export
 * @interface TimeslotResponsePaginated
 */
export interface TimeslotResponsePaginated {
    /**
     * 
     * @type {Array<TimeslotResponse>}
     * @memberof TimeslotResponsePaginated
     */
    timeslots?: Array<TimeslotResponse>;
    /**
     * 
     * @type {Pageable}
     * @memberof TimeslotResponsePaginated
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof TimeslotResponsePaginated
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the TimeslotResponsePaginated interface.
 */
export function instanceOfTimeslotResponsePaginated(value: object): value is TimeslotResponsePaginated {
    return true;
}

export function TimeslotResponsePaginatedFromJSON(json: any): TimeslotResponsePaginated {
    return TimeslotResponsePaginatedFromJSONTyped(json, false);
}

export function TimeslotResponsePaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotResponsePaginated {
    if (json == null) {
        return json;
    }
    return {
        
        'timeslots': json['timeslots'] == null ? undefined : ((json['timeslots'] as Array<any>).map(TimeslotResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : PageableFromJSON(json['pageable']),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function TimeslotResponsePaginatedToJSON(json: any): TimeslotResponsePaginated {
    return TimeslotResponsePaginatedToJSONTyped(json, false);
}

export function TimeslotResponsePaginatedToJSONTyped(value?: TimeslotResponsePaginated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeslots': value['timeslots'] == null ? undefined : ((value['timeslots'] as Array<any>).map(TimeslotResponseToJSON)),
        'pageable': PageableToJSON(value['pageable']),
        'totalCount': value['totalCount'],
    };
}

